import gql from 'graphql-tag'
import { companyFragment } from '@/graphql/company/companyFragments'
import { userProfileFragment, bestCandidateFragment, userProfileShortFragment } from '@/graphql/user/userProfileFragments'
import { ratedTagFragment, customTagFragment, tagFragment } from '@/graphql/tag/tagFragments'
import { assignmentFragment, draftAssignmentFragment } from "@/graphql/assignment/assignmentFragments";
import { absenceFragment, absenceTypeFragment } from '@/graphql/absence/absenceFragments'

    // isValidUser(
    //     email: String! @eq
    // ): isValidUser
    // @first


export const ISVALIDUSER = gql`
    query isValidUser(
        $email: String!
    ) {
        isValidUser(
            email: $email
        ){
            email
        }
    }
`
export const ROLES = gql`
    query {
        __type(name: "Role"){
            enumValues{
                name
                description
            }
        }
    }
`
export const MYPROFILE = gql`
    query myProfile {
        myProfile {
            ...userProfileFragment
            notificationsCount
            notificationsCountUnread
            assignmentsCount
            assignmentsCountUnaccepted 
            company{
                ...companyFragment
            }
            recover_navigation
            #professions {
            #    ...ratedTagFragment
            #}
            #courses {
            #    ...ratedTagFragment
            #}
            #skills {
            #    ...ratedTagFragment
            #}
            #customTags {
            #    ...customTagFragment
            #}
        }
    }
    ${userProfileFragment}
    ${companyFragment}
`
export const BESTCANDIDATE = gql`
    query bestCandidates (
        $professions: [ID!]
        $tags: [ID]
        $search: String
        $excludedUsers: [ID]
        $dates: [dateRangeInput]
        $daysOfWeek: [Int]
        $availability: String
        $sortByHiringDate: Boolean = false
    ){
        bestCandidates (
            professions: $professions
            tags: $tags
            search: $search
            excludedUsers: $excludedUsers
            dates: $dates
            daysOfWeek: $daysOfWeek
            availability: $availability
            sortByHiringDate: $sortByHiringDate
        )
        {
            ...bestCandidateFragment
            professions {
                ...ratedTagFragment
            }
            courses {
                ...ratedTagFragment
            }
            skills {
                ...ratedTagFragment
            }
            company {
                id
                categories{
                    id
                    color
                }
            }
        }
    }
    ${bestCandidateFragment}
    ${ratedTagFragment}
`

export const USERPROFILES = gql`
    query userProfiles (
        $ids: [ID]
        $role: [Role]
        $page: Int
        $first: Int
        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
        $trashed: Trashed
        $limitStaff: Boolean = false
    ){
        userProfiles (
            ids: $ids
            role: $role
            page: $page
            first: $first
            trashed: $trashed
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
            limitStaff: $limitStaff
        )
        {
            data{
                ...userProfileFragment
                company{
                    ...companyFragment
                }
                professions {
                    ...ratedTagFragment
                }
                courses {
                    ...ratedTagFragment
                }
                skills {
                    ...ratedTagFragment
                }
                customTags {
                    ...customTagFragment
                }
            }
        }
    }
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`
export const ALLUSERPROFILES = gql`
    query allUserProfiles (
        $ids: [ID]
        $role: [Role]
        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
        $trashed: Trashed
    ){
        allUserProfiles (
            ids: $ids
            role: $role
            trashed: $trashed
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        )
        {
            ...userProfileFragment
            company{
                ...companyFragment
            }
            professions {
                ...ratedTagFragment
            }
            courses {
                ...ratedTagFragment
            }
            skills {
                ...ratedTagFragment
            }
            customTags {
                ...customTagFragment
            }
        }
    }
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`
export const USERPROFILESSHORT = gql`
    query userProfiles (
        $ids: [ID]
        $role: [Role]
        $page: Int
        $first: Int
        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
    ){
        userProfiles (
            ids: $ids
            role: $role
            page: $page
            first: $first
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
        )
        {
            data{
                id
                email
                name
                label
            }
        }
    }
`
export const USERPROFILESSEARCHSHORT = gql`
    query userProfilesSearch (
        $searchText: String
        $page: Int
        $first: Int
    ){
        userProfilesSearch (
            searchText: $searchText
            page: $page
            first: $first
        )
        {
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                id
                email
                name
                label
            }
        }
    }
`
export const USERPROFILESSEARCH = gql`
    query userProfilesSearch (
        $searchText: String
        $page: Int
        $first: Int
    ){
        userProfilesSearch (
            searchText: $searchText
            page: $page
            first: $first
        )
        {
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...userProfileFragment
                company{
                    ...companyFragment
                }
                professions {
                    ...ratedTagFragment
                }
                courses {
                    ...ratedTagFragment
                }
                skills {
                    ...ratedTagFragment
                }
                customTags {
                    ...customTagFragment
                }
            }
        }
    }
    ${userProfileFragment}
    ${companyFragment}
    ${ratedTagFragment}
    ${customTagFragment}
`


export const USERPROFILESASSIGNMENTS = gql`
    query userProfiles (
        $ids: [ID]
        $projects: [ID]
        $role: [Role]
        $page: Int
        $first: Int
        $shiftsDateRange: activeDuringInputSingleDate!
        $moreFilters: MoreFiltersInput

        $orderBy: String = "name"
        $orderSort: SortOrder = ASC
        $limitStaff: Boolean = false
    ){
        userProfiles (
            ids: $ids
            role: $role
            page: $page
            first: $first
            moreFilters: $moreFilters
            orderBy:{
                field: $orderBy
                order: $orderSort
            }
            limitStaff: $limitStaff
        )
        {
            paginatorInfo{
                count
                perPage
                currentPage
                hasMorePages
                total
            }
            data{
                ...userProfileShortFragment
                absences(
                    dateRange: $shiftsDateRange
                )
                {
                    ...absenceFragment
                    type {
                        ...absenceTypeFragment
                    }
                }

                assignments(
                    dateRange: $shiftsDateRange
                    projects: $projects
                ){
                    ...assignmentFragment
                    profession{
                            ...tagFragment
                    }
                    accepted_by {
                        ...userProfileShortFragment
                    }
                }

                draftAssignments(
                    dateRange: $shiftsDateRange
                    projects: $projects
                ){
                    ...draftAssignmentFragment
                    project{
                        id
                        name
                    }
                    projectShift{
                        id
                        name
                    }
                    profession{
                            ...tagFragment
                    }
                    # accepted_by {
                    #     ...userProfileShortFragment
                    # }
                }

                company{
                    ...companyFragment
                }
                professions {
                    ...ratedTagFragment
                }
                courses {
                    ...ratedTagFragment
                }
                skills {
                    ...ratedTagFragment
                }
                customTags {
                    ...customTagFragment
                }
            }
        }
    }
    ${userProfileShortFragment}
    ${assignmentFragment}
    ${draftAssignmentFragment}
    ${companyFragment}
    ${tagFragment}
    ${ratedTagFragment}
    ${customTagFragment}
    ${absenceFragment}
    ${absenceTypeFragment}
`